<template>
  <v-radio-group
    class="zoox-component zoox-radio-group"
    hide-details="auto"
    :disabled="disabled"
    :column="column"
    :value="value"
    :on-icon="onIcon"
    :off-icon="offIcon"
    @change="onChange"
  >
    <div :class="{'is-column': column}">
      <template v-for="item of items">
        <z-radio
          :key="item.value"
          class="mx-2 mb-2"
          :color="color"
          v-bind="item"
        >
          <template #content>
            <!--@slot Slot de itens a serem consumidos pelo componente 
              @binding {object} item Itens passados ao componente
        -->
            <slot name="item" :item="item" />
          </template>
        </z-radio>
      </template>
    </div>
  </v-radio-group>
</template>

<script>
/**
 * @displayName Radio Group
 */
export default {
  name: 'ZRadioGroup',
  model: {
    model: 'value',
    event: 'change',
  },
  props: {
    /**
     * Valor associado a cada radio
     */
    value: {
      type: [Number, String],
    },
    /**
     * Itens a serem criados no formato
     *
     * @typedef Object {label:string,icon:string,description:string,value:any}
     */
    items: {
      type: Array,
    },
    /**
     * Flag para organizar os radios em colunas
     */
    column: {
      type: Boolean,
      default: false,
    },
    /**
     * Cor para ser utilizada no radio
     */
    color: {
      type: String,
    },
    /**
     * Flag para escolher o icone quando estiver ativo.
     */
    onIcon: {
      type: String,
      default: ' $radio_button_checked_rounded',
    },
    /**
     * Flag para escolher o icone quando estiver inativo.
     */
    offIcon: {
      type: String,
      default: '$radio_button_unchecked_rounded',
    },
    /**
     * Flag para indicar que o campo deve ficar desabilitado
     */
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onChange(value) {
      /**
       * Evento emitido ao clicar no radio
       *
       * @property {any} value - Valor da opção clicada
       */
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss" scoped>
.is-column {
  display: flex;
}
</style>
